import { IconsaxIcon } from "@/assets/iconsax";
import { theme } from "@/style";
import { Box } from "@flexisaf/flexibull2";
import { Icon } from "./icon";

type LabelWithIconProps = {
    icon: IconsaxIcon;
    text: string;
    color?: string;
};

export const LabelWithIcon = ({ icon, text, color }: LabelWithIconProps) => {
    return (
        <Box
            display="flex"
            style={{ alignItems: "center", color: `${color ?? theme.PrimaryGrey}` }}
        >
            <Box style={{ marginRight: "4px" }}>
                <Icon icon={icon} color={`${color ?? theme.PrimaryGrey}`} />
            </Box>
            <Box>{text}</Box>
        </Box>
    );
};
